"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.RowEval = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _index = require("../api/index");
var _ProjectRow = require("../classes/ProjectRow");
var _Eval3D = require("../classes/Eval3D");
var RowEval = /*#__PURE__*/function () {
  function RowEval(_ref) {
    var row = _ref.row,
      _ref$placerIndex = _ref.placerIndex,
      placerIndex = _ref$placerIndex === void 0 ? -1 : _ref$placerIndex,
      _ref$graphic = _ref.graphic,
      graphic = _ref$graphic === void 0 ? true : _ref$graphic,
      _ref$price = _ref.price,
      price = _ref$price === void 0 ? true : _ref$price,
      _ref$bom = _ref.bom,
      bom = _ref$bom === void 0 ? true : _ref$bom;
    (0, _classCallCheck2["default"])(this, RowEval);
    if (!row) throw new Error('Row can\'t be and empty field');
    this.row = row;
    this.placerIndex = placerIndex;
    this.graphic = graphic;
    this.price = price;
    this.bom = bom;
  }
  (0, _createClass2["default"])(RowEval, [{
    key: "eval",
    value: function () {
      var _eval2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var forced,
          _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              forced = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
              return _context.abrupt("return", RowEval.evalRow(this.row, this.placerIndex, forced, this.graphic, this.price, this.bom));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _eval() {
        return _eval2.apply(this, arguments);
      }
      return _eval;
    }()
  }], [{
    key: "eval",
    value: function () {
      var _eval3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(row) {
        var graphic,
          price,
          bom,
          _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              graphic = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : true;
              price = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : true;
              bom = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : true;
              return _context2.abrupt("return", RowEval.evalRow(row, -1, true, graphic, price, bom));
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function _eval(_x) {
        return _eval3.apply(this, arguments);
      }
      return _eval;
    }()
  }, {
    key: "evalRow",
    value: function () {
      var _evalRow = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(row) {
        var placerIndex,
          forced,
          graphic,
          price,
          bom,
          rowData,
          _args3 = arguments;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              placerIndex = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : -1;
              forced = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : false;
              graphic = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : true;
              price = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : true;
              bom = _args3.length > 5 && _args3[5] !== undefined ? _args3[5] : true;
              rowData = _ProjectRow.ProjectRow.getRowData(row, forced, placerIndex);
              row.jeval3ddone = false;
              return _context3.abrupt("return", new _promise["default"](function (resolve, reject) {
                RowEval._eval3D(row, rowData, graphic, price, bom).then(function (evalRes) {
                  try {
                    if (placerIndex > -1) {
                      var ruleData = evalRes.rule;
                      if (ruleData && row.placer[placerIndex].rule) {
                        row.placer[placerIndex].rule.setVariantData(ruleData);
                      }
                      evalRes.rule = null;
                    }
                    row.mergeEvalData(evalRes);
                  } catch (err) {
                    reject(err);
                  }
                  resolve(evalRes);
                })["catch"](reject);
              }));
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function evalRow(_x2) {
        return _evalRow.apply(this, arguments);
      }
      return evalRow;
    }()
  }, {
    key: "evalRowPlacer",
    value: function () {
      var _evalRowPlacer = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(row, prj) {
        var forced,
          rowsData,
          i,
          rowData,
          _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              forced = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : false;
              rowsData = [];
              for (i = 0; i < prj.rows.length; i++) {
                rowData = JSON.parse((0, _stringify["default"])(prj.rows[i]));
                rowData['rule'] = undefined;
                rowsData.push(rowData);
              }
              row.jeval3ddone = false;
              return _context4.abrupt("return", new _promise["default"](function (resolve, reject) {
                RowEval._evalPlacer(rowsData, row).then(function (evalRes) {
                  for (var _i = 0; _i < evalRes.length; _i++) {
                    var uniqueid = evalRes[_i].uniqueid || 0;
                    var _row = prj.getRowByUid(uniqueid);
                    if (_row) {
                      _row.mergeEvalData(evalRes[_i]);
                      if (_row.rule) {
                        _row.rule.setVariantData(evalRes[_i].rule);
                      }
                    }
                  }
                  resolve(evalRes);
                })["catch"](reject);
              }));
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function evalRowPlacer(_x3, _x4) {
        return _evalRowPlacer.apply(this, arguments);
      }
      return evalRowPlacer;
    }()
  }, {
    key: "_eval3D",
    value: function () {
      var _eval3D2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(row, baseRowData) {
        var graphic,
          price,
          bom,
          opts,
          _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              graphic = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : true;
              price = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : true;
              bom = _args5.length > 4 && _args5[4] !== undefined ? _args5[4] : true;
              opts = '';
              opts += graphic ? '1' : '0';
              opts += price ? '1' : '0';
              opts += bom ? '1' : '0';
              return _context5.abrupt("return", new _promise["default"](function (resolve, reject) {
                _index.CrulesAPI.eval3D(row.catalog, row.uniqueid, row.primoCaricamento, baseRowData, opts, function (json) {
                  resolve(new _Eval3D.Eval3D(json, graphic, price, bom));
                }, reject);
              }));
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function _eval3D(_x5, _x6) {
        return _eval3D2.apply(this, arguments);
      }
      return _eval3D;
    }()
  }, {
    key: "_eval3DWallItem",
    value: function () {
      var _eval3DWallItem2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(catalog, uniqueid, primoCaricamento, baseRowData) {
        var graphic,
          price,
          bom,
          opts,
          _args6 = arguments;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              graphic = _args6.length > 4 && _args6[4] !== undefined ? _args6[4] : true;
              price = _args6.length > 5 && _args6[5] !== undefined ? _args6[5] : true;
              bom = _args6.length > 6 && _args6[6] !== undefined ? _args6[6] : true;
              opts = '';
              opts += graphic ? '1' : '0';
              opts += price ? '1' : '0';
              opts += bom ? '1' : '0';
              opts += "1";
              return _context6.abrupt("return", new _promise["default"](function (resolve, reject) {
                _index.CrulesAPI.eval3D(catalog, uniqueid, primoCaricamento, baseRowData, opts, function (json) {
                  resolve(new _Eval3D.Eval3D(json, graphic, price, bom));
                }, reject);
              }));
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function _eval3DWallItem(_x7, _x8, _x9, _x10) {
        return _eval3DWallItem2.apply(this, arguments);
      }
      return _eval3DWallItem;
    }()
  }, {
    key: "_evalPlacer",
    value: function () {
      var _evalPlacer2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(baseRowsData, rowToEval) {
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", new _promise["default"](function (resolve, reject) {
                _index.CrulesAPI.evalPlacer(baseRowsData, rowToEval.uniqueid, function (json) {
                  if (json && json.length > 0) {
                    var evalResp = [];
                    for (var i = 0; i < json.length; i++) evalResp.push(new _Eval3D.Eval3D(json[i]));
                    resolve(evalResp);
                  } else reject(json);
                }, reject);
              }));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function _evalPlacer(_x11, _x12) {
        return _evalPlacer2.apply(this, arguments);
      }
      return _evalPlacer;
    }()
  }]);
  return RowEval;
}();
exports.RowEval = RowEval;
//# sourceMappingURL=RowEval.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/controllers/RowEval.js
// module id = 302
// module chunks = 142